<button
  *ngIf="!!users && users!.length > 0"
  mat-raised-button
  [disabled]="disabled"
  [color]="value ? 'primary' : 'accent'"
  (click)="selectUsers()"
>
  {{ getDisplayValue() }}
</button>
